import { IconButton, useTheme } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";

export function ShowMoreContentIcon({
  type,
  showMoreContent,
  setShowMoreContent
}: Readonly<{
  type: string;
  showMoreContent: boolean;
  setShowMoreContent: (showMore: boolean) => void;
}>) {
  const theme = useTheme();

  return (
    <IconButton
      onClick={() => setShowMoreContent(!showMoreContent)}
      data-testid={`${type}-content-btn`}
    >
      <ArrowForwardIos
        fontSize="small"
        sx={[
          {
            transition: theme.transitions.create("transform", {
              duration: theme.transitions.duration.shortest
            })
          },
          showMoreContent
            ? {
                transform: "rotate(90deg)"
              }
            : {
                transform: "rotate(0deg)"
              }
        ]}
      />
    </IconButton>
  );
}
